import { toast } from "react-toastify";

const normalizeHeader = (header) =>
  header?.toString().trim().replace(/\s*\*+$/, "");

export const validateExcelHeaders = (dataArray, fieldsMapping) => {
  let headerFieldCount = 0;
  if (dataArray.length === 0) {
    toast.error("Excel file is corrupted, plz download a new one!!");
    return false;
  }

  for (const mapping of fieldsMapping) {
    const acceptedHeaders = [mapping.excelName, ...(mapping.aliases ?? [])];
    const columnIndex = dataArray[0].findIndex((header) =>
      acceptedHeaders.includes(normalizeHeader(header))
    );

    if (columnIndex !== -1) {
      headerFieldCount++;
    }
  }

  if (headerFieldCount !== fieldsMapping.length) {
    toast.error("Excel file is corrupted, plz download a new one!!");
    return false;
  }

  if (dataArray.length === 1) {
    toast.error("File is empty, plz add data!!");
    return false;
  }

  return true;
};
